import React from 'react';
import { Text, DraftArea } from './fields';
import { selectedCode, offered } from '../orderingModel';
import './OrderingOptions.css';

export const OrderingOptionColumn = ({ column: c, onChange, testid }) => {
  const options = c.options || [];
  const enabled = offered(c);
  const setAll = value => onChange({ options: options.map(o => ({ ...o, enabled: value })) });
  function editOptions(text) {
    const next = text.split('\n').map(line => { const [code, ...label] = line.split('|'); return { code: code.trim(), label: label.join('|').trim() }; });
    onChange({ options: next.map(o => ({ ...options.find(old => old.code === o.code), ...o })) });
  }
  return <fieldset className="us-option-column" data-testid={testid} data-field-code={c.id}>
    <legend className="field-label">{c.title || 'Options'}</legend>
    <label className="us-option-check"><input type="checkbox" data-testid={testid + '-show-column'} checked={c.enabled !== false} onChange={e => onChange({ enabled: e.target.checked })} />Include this field</label>
    <div className="us-option-actions">
      <span data-testid={testid + '-count'}>{enabled.length} / {options.length} shown</span>
      <button type="button" className="btn btn-sm" data-testid={testid + '-show-all'} onClick={() => setAll(true)}>Select all</button>
      <button type="button" className="btn btn-sm" data-testid={testid + '-hide-all'} onClick={() => setAll(false)}>Deselect all</button>
    </div>
    <div className="us-option-list" data-testid={testid + '-list'}>
      {options.map((option, index) => <label key={index} className="us-option-check" data-testid={testid + '-option-label-' + index}>
        <input type="checkbox" data-testid={testid + '-option-' + index} aria-label={'Show ' + option.code + ' — ' + option.label}
          checked={option.enabled !== false} onChange={e => onChange({ options: options.map((o, i) => i === index ? { ...o, enabled: e.target.checked } : o) })} />
        <span><b>{option.code}</b> — {option.label}</span>
      </label>)}
    </div>
    <div className="field" style={{ marginTop: 10 }}><label className="field-label">Example selection</label>
      <select className="select" data-testid={testid + '-selected'} value={selectedCode(c)} disabled={!enabled.length} onChange={e => onChange({ selected: e.target.value })}>
        {!enabled.length && <option value="">No options shown</option>}
        {enabled.map((option, i) => <option key={i} value={option.code}>{option.code} · {option.label}</option>)}
      </select>
    </div>
    <details className="us-option-edit" data-testid={testid + '-edit'}><summary data-testid={testid + '-edit-toggle'}>Edit labels / custom options</summary>
      <Text label="Column heading" value={c.title} onChange={title => onChange({ title })} testid={testid + '-title'} />
      <DraftArea label="Options" hint="CODE | Description, one per line" text={options.map(o => `${o.code || ''} | ${o.label || ''}`).join('\n')} onText={editOptions} testid={testid + '-options'} rows={4} />    </details>
  </fieldset>;
};